/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "970058ad9d5ba6abb52427e382ad8408edba23f5";
